import { FC } from 'react'
import * as styles from 'components/features/pfm/StepIndicator/StepIndicator.css'

export const INDICATOR_CARD_SUCCESS_STEP = 'card-success' as const
export const INDICATOR_EXCLAMATION_STEP = 'exclamation' as const
export const INDICATOR_CHECK_STEP = 'check' as const
export const INDICATOR_COMPLETE_STEP = 'complete' as const

type IndicatorExtraSteps =
  | typeof INDICATOR_CHECK_STEP
  | typeof INDICATOR_CARD_SUCCESS_STEP
  | typeof INDICATOR_EXCLAMATION_STEP
  | typeof INDICATOR_COMPLETE_STEP


export type StepIndicatorProps = {
  step: number | IndicatorExtraSteps
  maxStep: number
}

const StepIndicator: FC<StepIndicatorProps> = (props) => {
  const { step, maxStep } = props

  if (step === INDICATOR_CHECK_STEP) {
    return (
      <div className={ styles.checkStep } data-qa-marker='step-indicator-last' />
    )
  }

  if (step === INDICATOR_CARD_SUCCESS_STEP) {
    return (
      <div className={ styles.cardSuccess } data-qa-marker='step-indicator-success' />
    )
  }

  if (step === INDICATOR_EXCLAMATION_STEP) {
    return (
      <div className={ styles.exclamation } data-qa-marker='step-indicator-exclamation' />
    )
  }

  if (step > maxStep || step === INDICATOR_COMPLETE_STEP) {
    return (
      <div className={ styles.stepCompleted } data-qa-marker='step-indicator-completed' />
    )
  }

  const qaMarker = `step-indicator-${ step }-${ maxStep }`

  return (
    <div className={ styles.stepIndicator }>
      <span className={ styles.value } data-qa-marker={ qaMarker }>
        { `${ step }/${ maxStep }` }
      </span>
    </div>
  )
}

export default StepIndicator
